import moment from 'moment';

export const updatePositionWithoutConnect = (
    position,
    resultPositions,
    planned,
    difference,
    allPositions
) => {
    let result = { ...resultPositions };

    if (!position.planned.days_count) return result;

    const duration = moment.duration(
        moment(planned.end_date).diff(moment(position.planned.end_date))
    );
    const daysDiff = Math.round(+duration.asDays());

    let differenceRemainder = daysDiff - difference;

    if (differenceRemainder > 0) {
        return result;
    }

    differenceRemainder = Math.abs(differenceRemainder);

    const daysFromStartCharter = moment(position.planned.start_date).diff(
        planned.start_date,
        'days'
    );

    if (daysFromStartCharter >= differenceRemainder) {
        const planned = {
            ...position.planned,
            start_date: moment(position.planned.start_date)
                .add(-differenceRemainder, 'days')
                .format(),
            end_date: moment(position.planned.end_date).add(-differenceRemainder, 'days').format(),
        };

        result[position.guid] = { ...result[position.guid], planned };
        differenceRemainder = 0;
    } else {
        const planned = {
            ...position.planned,
            start_date: moment(position.planned.start_date)
                .add(-daysFromStartCharter, 'days')
                .format(),
            end_date: moment(position.planned.end_date).add(-daysFromStartCharter, 'days').format(),
        };

        result[position.guid] = { ...result[position.guid], planned };
        differenceRemainder -= daysFromStartCharter;
    }

    if (differenceRemainder > 0) {
        const currentPosition = result[position.guid];

        const planned = {
            ...currentPosition.planned,
            days_count: `${+currentPosition.planned.days_count - differenceRemainder}`,
            end_date: moment(currentPosition.planned.end_date)
                .add(-differenceRemainder, 'days')
                .format(),
        };

        result[position.guid] = { ...currentPosition, planned };
    }

    return result;
};
